// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 11/10/2023
 */

.ServiceDetails_container__Xaytg {
  border-radius: 0.5rem;
  padding: 0rem;
  margin-bottom: 4rem;
  text-align: left;
}

.ServiceDetails_description__9prl6 {
  color: #000000;
  text-align: center;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 500;
  margin-top: 2rem;
  margin-bottom: 1.75rem;
}

.ServiceDetails_card__y08vX {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem;
  padding: 0rem;
  padding-bottom: 0rem;

  /* border: 2px solid #486dac5e;  */
  /* background-color: #002566; */
  /* background-color: rgba(101, 127, 173, 0.1); */
  background-color: rgba(255, 255, 255, 0.1);
}

.ServiceDetails_topCard__kmr5d {
  box-shadow: none;
  border-radius: 0.5rem;
  /* padding: 1.5rem; */
  /* border: 2px solid #486dac5e; */
  background-color: rgba(255, 255, 255, 0);
  padding-right: 0rem;
}

.ServiceDetails_subCardContainer__4WctM {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.ServiceDetails_imageOverlay__Farip {
  position: relative;
  width: 100%;
  height: 100%;
}

.ServiceDetails_cardMedia__ZX095 {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
}

.ServiceDetails_overlayText__VyyNT {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.527);
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  /* color: #1E3A5F; */
}

.ServiceDetails_overlayTitle__vVOPy {
  font-size: 3rem;
  font-weight: 100;
  margin-bottom: 0.5rem;
  text-align: center;
  font-family: "Georgia", "Times New Roman", serif;
  position: absolute;
  top: 4rem; 
}

.ServiceDetails_overlayDescription__IeasY {
  font-size: 0.8rem;
  font-weight: 300;
  text-align: center;
  margin: 1.5rem;
  font-family: "Open Sans", sans-serif;
}

.ServiceDetails_rightColumn__MO4tA {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 1rem;
}

.ServiceDetails_subCard__51YRN {
  display: flex;
  width: 52vw;
  height: 9rem;
  /* box-shadow: 1 4px 8px rgba(0, 0, 0, 0.1); */
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: rgba(101, 127, 173, 0.137);
}

.ServiceDetails_subCardContent__eQr5f {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.ServiceDetails_subCardImage__NaQzp {
  width: 30%;
  object-fit: cover;
  /* padding: 1rem; */
}

.ServiceDetails_subCardText__nYFoh {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60%;
  color: #000000ea;
  margin-left: 1rem;
}

.ServiceDetails_subCardTextOne__uoGu6 {
  font-size: 1.5rem;
}

.ServiceDetails_subCardTextTwo__1jTAI {
  font-size: 0.9rem;
}

.ServiceDetails_divider__osT\\+7 {
  border: none;
  border-top: 1px solid #ddd;
  margin: 1rem 0;
  width: 100%;
}

.ServiceDetails_button__le5Qw {
  position: absolute;
  bottom: 4rem; 
  left: 50%;
  transform: translateX(-50%); 
  margin: 0; 
  border-radius: 0.5rem;
  padding: 0.4rem 1.5rem;
  box-shadow: none;
}

@media (max-width: 770px) {
  .ServiceDetails_card__y08vX {
    padding: 0rem;
  }

  .ServiceDetails_description__9prl6 {
    margin: 0 0.5rem;
    font-size: 0.8rem;
  }

  .ServiceDetails_container__Xaytg {
    padding: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
  }

  .ServiceDetails_rightColumn__MO4tA {
    padding: 0.5rem 0rem;
  }

  .ServiceDetails_subCardWrapper__Y6JlL {
    width: 100%;
    margin-bottom: 0.1rem;
    padding-bottom: 0rem;
  }

  .ServiceDetails_subCard__51YRN {
    width: 100%;
    height: 7rem;
    flex-direction: column;
  }

  .ServiceDetails_subCardImage__NaQzp {
    width: 30%;
    height: 7rem;
    object-fit: cover;
  }

  .ServiceDetails_subCardText__nYFoh {
    width: 100%;
    padding: 0.1rem;
    font-size: 0.1rem;
    text-align: center;
    margin-left: 0.1rem;
  }

  .ServiceDetails_overlayTitle__vVOPy {
    font-size: 1.5rem;
  }

  .ServiceDetails_overlayDescription__IeasY {
    font-size: 0.7rem;
  }

  .ServiceDetails_topCard__kmr5d {
    padding-right: 0rem;
  }
  .ServiceDetails_subCardTextOne__uoGu6 {
    font-size: 0.8rem;
  }

  .ServiceDetails_subCardTextTwo__1jTAI {
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/services/ServiceDetails.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4EAA4E;EAC5E,qBAAqB;EACrB,aAAa;EACb,oBAAoB;;EAEpB,kCAAkC;EAClC,+BAA+B;EAC/B,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 11/10/2023\r\n */\r\n\r\n.container {\r\n  border-radius: 0.5rem;\r\n  padding: 0rem;\r\n  margin-bottom: 4rem;\r\n  text-align: left;\r\n}\r\n\r\n.description {\r\n  color: #000000;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  margin-top: 2rem;\r\n  margin-bottom: 1.75rem;\r\n}\r\n\r\n.card {\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.08);\r\n  border-radius: 0.5rem;\r\n  padding: 0rem;\r\n  padding-bottom: 0rem;\r\n\r\n  /* border: 2px solid #486dac5e;  */\r\n  /* background-color: #002566; */\r\n  /* background-color: rgba(101, 127, 173, 0.1); */\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.topCard {\r\n  box-shadow: none;\r\n  border-radius: 0.5rem;\r\n  /* padding: 1.5rem; */\r\n  /* border: 2px solid #486dac5e; */\r\n  background-color: rgba(255, 255, 255, 0);\r\n  padding-right: 0rem;\r\n}\r\n\r\n.subCardContainer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: 16px;\r\n}\r\n\r\n.imageOverlay {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.cardMedia {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.overlayText {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.527);\r\n  color: rgb(255, 255, 255);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 0.5rem;\r\n  /* color: #1E3A5F; */\r\n}\r\n\r\n.overlayTitle {\r\n  font-size: 3rem;\r\n  font-weight: 100;\r\n  margin-bottom: 0.5rem;\r\n  text-align: center;\r\n  font-family: \"Georgia\", \"Times New Roman\", serif;\r\n  position: absolute;\r\n  top: 4rem; \r\n}\r\n\r\n.overlayDescription {\r\n  font-size: 0.8rem;\r\n  font-weight: 300;\r\n  text-align: center;\r\n  margin: 1.5rem;\r\n  font-family: \"Open Sans\", sans-serif;\r\n}\r\n\r\n.rightColumn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  height: 100%;\r\n  padding: 1rem;\r\n}\r\n\r\n.subCard {\r\n  display: flex;\r\n  width: 52vw;\r\n  height: 9rem;\r\n  /* box-shadow: 1 4px 8px rgba(0, 0, 0, 0.1); */\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n  background-color: rgba(101, 127, 173, 0.137);\r\n}\r\n\r\n.subCardContent {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n}\r\n\r\n.subCardImage {\r\n  width: 30%;\r\n  object-fit: cover;\r\n  /* padding: 1rem; */\r\n}\r\n\r\n.subCardText {\r\n  padding: 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  width: 60%;\r\n  color: #000000ea;\r\n  margin-left: 1rem;\r\n}\r\n\r\n.subCardTextOne {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.subCardTextTwo {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.divider {\r\n  border: none;\r\n  border-top: 1px solid #ddd;\r\n  margin: 1rem 0;\r\n  width: 100%;\r\n}\r\n\r\n.button {\r\n  position: absolute;\r\n  bottom: 4rem; \r\n  left: 50%;\r\n  transform: translateX(-50%); \r\n  margin: 0; \r\n  border-radius: 0.5rem;\r\n  padding: 0.4rem 1.5rem;\r\n  box-shadow: none;\r\n}\r\n\r\n@media (max-width: 770px) {\r\n  .card {\r\n    padding: 0rem;\r\n  }\r\n\r\n  .description {\r\n    margin: 0 0.5rem;\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .container {\r\n    padding: 0;\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n\r\n  .rightColumn {\r\n    padding: 0.5rem 0rem;\r\n  }\r\n\r\n  .subCardWrapper {\r\n    width: 100%;\r\n    margin-bottom: 0.1rem;\r\n    padding-bottom: 0rem;\r\n  }\r\n\r\n  .subCard {\r\n    width: 100%;\r\n    height: 7rem;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .subCardImage {\r\n    width: 30%;\r\n    height: 7rem;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .subCardText {\r\n    width: 100%;\r\n    padding: 0.1rem;\r\n    font-size: 0.1rem;\r\n    text-align: center;\r\n    margin-left: 0.1rem;\r\n  }\r\n\r\n  .overlayTitle {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .overlayDescription {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .topCard {\r\n    padding-right: 0rem;\r\n  }\r\n  .subCardTextOne {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .subCardTextTwo {\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ServiceDetails_container__Xaytg`,
	"description": `ServiceDetails_description__9prl6`,
	"card": `ServiceDetails_card__y08vX`,
	"topCard": `ServiceDetails_topCard__kmr5d`,
	"subCardContainer": `ServiceDetails_subCardContainer__4WctM`,
	"imageOverlay": `ServiceDetails_imageOverlay__Farip`,
	"cardMedia": `ServiceDetails_cardMedia__ZX095`,
	"overlayText": `ServiceDetails_overlayText__VyyNT`,
	"overlayTitle": `ServiceDetails_overlayTitle__vVOPy`,
	"overlayDescription": `ServiceDetails_overlayDescription__IeasY`,
	"rightColumn": `ServiceDetails_rightColumn__MO4tA`,
	"subCard": `ServiceDetails_subCard__51YRN`,
	"subCardContent": `ServiceDetails_subCardContent__eQr5f`,
	"subCardImage": `ServiceDetails_subCardImage__NaQzp`,
	"subCardText": `ServiceDetails_subCardText__nYFoh`,
	"subCardTextOne": `ServiceDetails_subCardTextOne__uoGu6`,
	"subCardTextTwo": `ServiceDetails_subCardTextTwo__1jTAI`,
	"divider": `ServiceDetails_divider__osT+7`,
	"button": `ServiceDetails_button__le5Qw`,
	"subCardWrapper": `ServiceDetails_subCardWrapper__Y6JlL`
};
export default ___CSS_LOADER_EXPORT___;
